import React from 'react'
// Ikony PEŁNE, nie konturowe jak reszta paska — kontur w kolorze to cienka
// kreska, która ginie; wypełniony kształt niesie barwę.
import { MoonIcon, SunIcon } from '@heroicons/react/24/solid'
import { useTheme } from '../ThemeContext'
import { useTranslation } from 'react-i18next'

/**
 * Przełącznik motywu jasny / ciemny.
 *
 * Ikona pokazuje DOKĄD prowadzi kliknięcie, nie stan bieżący: w jasnym motywie
 * widać księżyc („włącz ciemny"), w ciemnym słońce („wróć do jasnego"). Odwrotna
 * konwencja też się spotyka, ale wtedy przycisk czyta się jak informacja,
 * a to jest przycisk.
 *
 * Sam kształt ikony niesie całe znaczenie, więc podpisu nie ma — stan dla
 * czytnika ekranu dokłada `aria-pressed` i `aria-label`.
 */
const ToggleThemeButton = ({ className = '' }) => {
  const { t } = useTranslation('wspolne')
  const { ciemny, przelaczMotyw } = useTheme()
  const opis = ciemny ? t('motyw.jasny') : t('motyw.ciemny')

  return (
    <button
      type='button'
      onClick={przelaczMotyw}
      title={opis}
      aria-label={opis}
      aria-pressed={ciemny}
      className={`flex items-center justify-center p-2 rounded-lg
                  hover:bg-gray-100 transition-colors ${className}`}
    >
      {/* Kolor niesie sama ikona, więc na `hover` zmienia się TŁO, a nie tekst —
          `hover:text-blue-600` jak w sąsiednich zakładkach zamalowywałby tu
          bursztyn i granat na niebiesko.
          Bursztynowe słońce i granatowy księżyc to konwencja czytelna bez podpisu;
          odcienie 400/500 są dobrane tak, by każda ikona miała kontrast na TYM
          tle, na którym się pokazuje — słońce wyłącznie na ciemnym pasku,
          księżyc wyłącznie na jasnym. */}
      {ciemny
        ? <SunIcon className='w-5 h-5 text-amber-400' />
        : <MoonIcon className='w-5 h-5 text-indigo-500' />}
    </button>
  )
}

export default ToggleThemeButton
